import React from 'react';

import i18n from 'Utilities/i18n';

import greenCheck from 'Images/green-check.svg';

const Header: React.FC = () => {
  return (
    <header className="d-flex justify-content-between align-items-center">
      <div className="d-flex">
        <span className="text-xl text-black">{i18n.t('Common.connected')}</span>
        <img className="px-1" id="green-check" src={greenCheck} alt="check" />
      </div>
    </header>
  );
};

export default Header;
